import { render } from "./SystemSecurityPages.vue?vue&type=template&id=5152f0ef&scoped=true"
import script from "./SystemSecurityPages.vue?vue&type=script&lang=js"
export * from "./SystemSecurityPages.vue?vue&type=script&lang=js"

import "./SystemSecurityPages.vue?vue&type=style&index=0&id=5152f0ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5152f0ef"]])

export default __exports__